<template>
  <div class="container-fluid bg-light">
    <div class="row title-card">
      <div class="col-10 text-left text-dark"><h4>Cadastro de Usuários</h4></div>
      <div class="col-2 text-right">
        <b-link class="text-dark" :to="{ name: 'home' }">
          <icon name="times" scale="2"></icon>
        </b-link>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-right">
        <b-btn v-b-modal.newUser variant="success">Novo Usuário</b-btn>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col" class="text-right">Opções</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(user, index) in users" v-bind:key="'user-'+index">
            <td class="align-middle"><strong v-if="user.st_user == 1">{{ user.nm_user }}</strong>
              <template v-else>{{ user.nm_user }}</template>
            </td>
            <td class="text-right">
              <div class="btn-toolbar float-right" role="toolbar">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary" @click="setUser(user)" v-b-modal.editUser>
                    <icon name="pencil" scale="1.2" class="align-middle"></icon>
                  </button>
                  <button type="button" class="btn btn-warning" @click="getStores(user)" :disabled="user.st_user == 2"
                          v-b-modal.getStores>
                    <icon name="list" scale="1.2" class="align-middle text-white"></icon>
                  </button>
                  <button type="button" class="btn btn-info" @click="getPermissoesCheck(user)"
                          :disabled="user.st_user == 2" v-b-modal.getPermissoesCheck>
                    <icon name="gear" scale="1.2" class="align-middle text-white"></icon>
                  </button>
                  <b-button v-b-tooltip.hover class="btn btn-success" @click="changeStatus(user)"
                            v-if="user.active == '1'" title="Desativar">
                    <icon name="check" scale="1.2" class="align-middle"></icon>
                  </b-button>
                  <b-button v-b-tooltip.hover class="btn btn-danger" @click="changeStatus(user)"
                            v-if="user.active == '0'" title="Ativar">
                    <icon name="ban" scale="1.2" class="align-middle"></icon>
                  </b-button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Novo Usuário -->
    <b-modal id="newUser" ref="modalNew" title="Novo Usuário" @ok="newUser" @hidden="clearData" no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="nnomeUser">Nome</label>
          <input type="text" class="form-control" id="nnomeUser" v-model="novoUsuario.nome" required>
        </div>
        <div class="form-row">
          <div class="form-group col-6">
            <label for="ntipoUser">Tipo</label>
            <select class="custom-select" id="ntipoUser" v-model="novoUsuario.tipo" required>
              <option value="1">Supervisor</option>
              <option value="2">Loja</option>
            </select>
          </div>
          <div class="form-group col-6">
            <label for="npermUser" v-show="novoUsuario.tipo == 1">Pode configurar o sistema?</label>
            <select class="custom-select" id="npermUser" v-model="novoUsuario.permissao" v-show="novoUsuario.tipo == 1"
                    required>
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="nemailUser">E-mail</label>
          <input type="email" class="form-control" id="nemailUser" v-model="novoUsuario.email" required>
        </div>
        <div class="form-group">
          <label for="npassUser">Senha</label>
          <input type="password" class="form-control" id="npassUser" v-model="novoUsuario.pass" required>
        </div>
      </form>
    </b-modal>

    <!-- Modal Editar Usuário -->
    <b-modal id="editUser" ref="modalEdit" title="Editar Usuário" @ok="editUser" @hidden="clearData"
             no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="nomeUser">Nome</label>
          <input type="text" class="form-control" id="nomeUser" v-model="editarUsuario.nome" required>
        </div>
        <div class="form-row">
          <div class="form-group col-6">
            <label for="tipoUser">Tipo</label>
            <select class="custom-select" id="tipoUser" v-model="editarUsuario.tipo" required>
              <option value="1">Supervisor</option>
              <option value="2">Loja</option>
            </select>
          </div>
          <div class="form-group col-6">
            <label for="permUser" v-show="editarUsuario.tipo == 1">Pode configurar o sistema?</label>
            <select class="custom-select" id="permUser" v-model="editarUsuario.permissao"
                    v-show="editarUsuario.tipo == 1" required>
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="emailUser">E-mail</label>
          <input type="email" class="form-control" id="emailUser" v-model="editarUsuario.email" required>
        </div>
        <div class="form-group">
          <label for="passUser">Senha</label>
          <input type="password" class="form-control" id="passUser" v-model="editarUsuario.pass" required>
        </div>
      </form>
    </b-modal>

    <!-- Modal Lojas -->
    <b-modal id="getStores" ref="modalStore" title="Permissões (Lojas)" @ok="savePermissoes" @hidden="clearData"
             no-close-on-backdrop>
      <form @submit="onSubmit">
        <b-form-checkbox-group stacked v-model="permissoes.selected" name="stores"
                               :options="permissoes.options"></b-form-checkbox-group>
      </form>
    </b-modal>

    <!-- Modal Permissoes -->
    <b-modal id="getPermissoesCheck" ref="modalPermissoesCheck" title="Permissões (Checks)" @ok="savePermissoesCheck"
             @hidden="clearData" no-close-on-backdrop>
      <form @submit="onSubmit">
        <b-form-checkbox class="form-control-sm" id="checkbox-1" v-model="statusCheck_value" name="checkbox-1"
                         value="accepted" value-text="teste" unchecked-value="not_accepted" @change="statusCheck">
          <b>{{ statusCheck_text }}</b>
        </b-form-checkbox>
        <b-form-checkbox-group stacked v-model="permissoesCheck.selected" name="checks"
                               :options="permissoesCheck.options"></b-form-checkbox-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {http} from '../http'
import swal from 'sweetalert'
import Icon from 'vue-awesome'

export default {
  components: {Icon},
  data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      novoUsuario: {nome: null, tipo: null, permissao: null, email: null, pass: null},
      editarUsuario: {user: null, nome: null, tipo: null, permissao: null, email: null, pass: null, active: null},
      permissoes: {
        usuario: null,
        selected: [],
        options: []
      },
      permissoesCheck: {
        usuario: null,
        selected: [],
        selectedAux: [],
        options: []
      },
      users: [],
      stores: [],
      txt: '',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      statusCheck_value: 'accepted',
      statusCheck_text: ''
    }
  },
  beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home')
    if (localStorage.getItem('admin') == 'false') this.$router.push('home')
  },
  mounted() {
    http.get('/user/all').then(response => {
      this.users = response.data;
    })
    http.get('/store/all').then(response => {
      this.stores = response.data;
    })
    this.setStatusCheck()
  },
  methods: {
    isEmailValid(email) {
      return (email === "") ? false : (this.reg.test(email)) ? true : false;
    },
    onSubmit(evt) {
      evt.preventDefault();
    },
    newUser(evt) {
      evt.preventDefault();
      if (!this.novoUsuario.nome) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um nome para o novo usuário.',
          dangerMode: true,
        })
      } else if (!this.novoUsuario.tipo) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um tipo para o novo usuário.',
          dangerMode: true,
        })
      } else if (this.isEmailValid(this.novoUsuario.email) === false) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um e-mail valido para o novo usuário.',
          dangerMode: true,
        })
      } else if (!this.novoUsuario.pass) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe uma senha para o novo usuário.',
          dangerMode: true,
        })
      } else {
        var jSON = {
          nome: this.novoUsuario.nome,
          tipo: this.novoUsuario.tipo,
          permissao: (this.novoUsuario.tipo == 1) ? (this.novoUsuario.permissao == 1) ? 1 : 0 : 0,
          email: this.novoUsuario.email,
          password: this.novoUsuario.pass
        }
        http.post('/user/save', jSON)
          .then(response => {
            this.clearData()
            this.$refs.modalNew.hide()
            swal({
              icon: 'success',
              title: 'Ok!',
              text: 'Novo usuário cadastrado.'
            })
            http.get('/user/all').then(response => {
              this.users = response.data;
            })
          })
          .catch((error) => {
            swal({
              icon: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem,
              dangerMode: true,
            })
          })
      }
    },
    editUser(evt) {
      evt.preventDefault();
      if (!this.editarUsuario.nome) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um nome para o novo usuário.',
          dangerMode: true,
        })
      } else if (this.isEmailValid(this.editarUsuario.email) === false) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um e-mail valido para o novo usuário.',
          dangerMode: true,
        })
      } else {
        var jSON = {
          id: this.editarUsuario.user,
          nome: this.editarUsuario.nome,
          tipo: this.editarUsuario.tipo,
          permissao: (this.editarUsuario.tipo == 1) ? (this.editarUsuario.permissao == 1) ? 1 : 0 : 0,
          email: this.editarUsuario.email,
          password: this.editarUsuario.pass,
          active: this.editarUsuario.active,
        }
        // Requisição para gravar as alterações.
        http.post('/user/update', jSON)
          .then(response => {
            this.clearData()
            this.$refs.modalEdit.hide()
            swal({
              icon: 'success',
              title: 'Salvo!',
              text: 'Informações gravadas com sucesso!'
            })
            http.get('/user/all').then(response => {
              this.users = response.data;
            })
          })
          .catch((error) => {
            swal({
              icon: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem,
              dangerMode: true,
            })
          })
      }
    },
    getPermissoesCheck(user) {
      // Buscando as lojas que o supervisor tem permissão.
      http.get('/permissoes/all/' + user.id_user).then(response => {
        this.permissoesCheck.usuario = user.id_user
        response.data.forEach(check => {
          this.permissoesCheck.options.push({text: check.nm_check, value: check.id_check})
          this.permissoesCheck.selectedAux.push(check.id_check)
          if (check.id_user != null) {
            this.permissoesCheck.selected.push(check.id_check)
          }
        })

        if (this.permissoesCheck.selected.length == 0) {
          this.permissoesCheck.selected = this.permissoesCheck.selectedAux;
        }

        if (this.permissoesCheck.selected.length == this.permissoesCheck.selectedAux.length) {
          this.statusCheck_value = 'accepted'
        } else {
          this.statusCheck_value = 'not_accepted'
        }

        this.setStatusCheck()

      })

    },
    savePermissoesCheck(evt) {
      evt.preventDefault();

      if (this.permissoesCheck.selected.length == 0) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Nenhum item foi selecionado.',
          dangerMode: true,
        })
      } else {
        http.post('/permissoes/save', {id_user: this.permissoesCheck.usuario, checks: this.permissoesCheck.selected})
          .then(response => {
            this.clearData()
            this.$refs.modalPermissoesCheck.hide()
            swal({
              icon: 'success',
              title: 'Ok!',
              text: 'Permissões gravadas.'
            })
            http.get('/user/all').then(response => {
              this.users = response.data;
            })
            http.get('/store/all').then(response => {
              this.stores = response.data;
            })
          })
      }
    },
    getStores(user) {
      // Buscando as lojas que o supervisor tem permissão.
      http.get('/store/all/supervisor/' + user.id_user).then(response => {
        this.permissoes.usuario = user.id_user
        response.data.forEach(store => {
          this.permissoes.selected.push(store.id_store)
        })
      })

      this.stores.forEach(e => {
        // Criando as opções no array de checkboxes.
        this.permissoes.options.push({text: e.nm_store, value: e.id_store})

        // Verificando as lojas que o supervisor tem acesso para trazer selecionado no checkboxes.
        if (e.id_user == user.id_user) {
          this.permissoes.selected.push(e.id_store)
        }
      });
    },
    savePermissoes(evt) {
      evt.preventDefault();

      http.post('/user/permissoes', {id_user: this.permissoes.usuario, stores: this.permissoes.selected})
        .then(response => {
          this.clearData()
          this.$refs.modalStore.hide()
          swal({
            icon: 'success',
            title: 'Ok!',
            text: 'Permissões gravadas.'
          })
          http.get('/user/all').then(response => {
            this.users = response.data;
          })
          http.get('/store/all').then(response => {
            this.stores = response.data;
          })
        })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    changeStatus(user) {

      if (user.active == 1) {
        user.active = 0;
        this.txt = 'inativado';
      } else {
        user.active = 1;
        this.txt = 'Ativado';
      }

      var jSON = {
        id: user.id_user,
        nome: user.nm_user,
        tipo: user.st_user,
        permissao: user.ad_user,
        email: user.em_user,
        active: user.active,
      }

      // Requisição para inativar o usuário.
      http.post('/user/update', jSON)
        .then(response => {
          swal({
            icon: 'success',
            title: 'Salvo!',
            text: 'Usuário ' + this.txt + '.'
          })
          http.get('/user/all').then(response => {
            this.users = response.data;
          })
        })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    setUser(user) {
      this.editarUsuario.user = user.id_user
      this.editarUsuario.nome = user.nm_user
      this.editarUsuario.tipo = user.st_user
      this.editarUsuario.permissao = user.ad_user
      this.editarUsuario.email = user.em_user
      this.editarUsuario.active = user.active
    },
    clearData(evt) {
      this.editarUsuario.user = null
      this.editarUsuario.nome = null
      this.editarUsuario.tipo = null
      this.editarUsuario.permissao = null
      this.editarUsuario.email = null
      this.editarUsuario.active = null
      this.novoUsuario.nome = null
      this.novoUsuario.tipo = null
      this.novoUsuario.permissao = null
      this.novoUsuario.email = null
      this.novoUsuario.pass = null
      this.permissoes.usuario = null
      this.permissoes.selected = []
      this.permissoes.options = []
      this.permissoesCheck.usuario = null
      this.permissoesCheck.selected = []
      this.permissoesCheck.options = []
      this.permissoesCheck.selectedAux = []
    },
    statusCheck() {
      this.setStatusCheck()

      if (this.statusCheck_value == 'accepted') {
        this.permissoesCheck.selected = this.permissoesCheck.selectedAux
      } else {
        this.permissoesCheck.selected = []
      }
    },
    setStatusCheck() {
      if (this.statusCheck_value == 'accepted') {
        this.statusCheck_text = 'Desmarcar todos'
      } else {
        this.statusCheck_text = 'Marcar todos'
      }
    }
  }
}
</script>

<style scoped>
.container-fluid {
  min-height: 100vh;
}

.container-fluid .title-card {
  padding: 20px 0;
}

.container-fluid .title-card h4 {
  font-size: 1.5em;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users.vue